<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑广告' : '新增广告'"
      :visible.sync="showAddOrEdit"
      width="500px"
      :before-close="cancelFun"
    >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="页面" prop="pageCode" :rules="rules">
            <el-select v-model="formData.pageCode" placeholder="请选择" size="small" style="width: 100%;">
              <el-option v-for="item in pageList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图片" prop="image" :rules="rules">
            <FileUpload
              :isMulti="false"
              :limit="1"
              :name.sync="formData.image"
              :url="formData.imageUrl"
            ></FileUpload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权重" prop="weight" :rules="rules">
            <el-input-number
              v-model="formData.weight"
              placeholder="请输入"
              size="small"
              style="width: 100%;"
              :precision="0" :step="1" :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
      <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import FileUpload from "@/components/file-upload/index.vue";

import { getOprtAdDetailAPI, addOprtAdAPI, editOprtAdAPI } from "./api";
export default {
  name: "AddOrEdit",
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      formData: {
        name: "",
        pageCode: "",
        image: "",
        imageUrl: "",
        weight: "",
        remark: "",
      },
      pageList: [{
        name:'首页',
        value:'home'
      },{
        name:'我的',
        value:'mine'
      }],
    };
  },

  mounted() {
    if (this.rowId) this.getChannelDetail();
  },

  methods: {
    submitFun() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          (this.rowId ? editOprtAdAPI : addOprtAdAPI)(this.formData).then(() => {
            this.$message.success(this.rowId ? "编辑成功" : "新增成功");
            this.$emit("closeDialog",true);
          });
        }
      });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
    async getChannelDetail() {
      this.formData = await getOprtAdDetailAPI(this.rowId);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}
</style>
